module.exports = __webpack_public_path__ + "img/SE.475c6d60.svg";